import React, { useState, useEffect } from "react";
import {
  Typography,
  FormControl,
  FormControlLabel,
  Checkbox,
} from "@material-ui/core";
import ActionButton from "../../components/ActionButton";
import { makeStyles } from "@material-ui/core/styles";
import { useSnackbar } from "notistack";
import { useTranslation } from "react-i18next";
import PropertyNames from "../../PropertyNames";
import { useSelector, useDispatch } from "react-redux";
import { setApplicationProperties } from "../../redux/actions/universalActions.js";
import "filepond/dist/filepond.min.css";
import axios from "../../AxiosClient";
import SearchSecondaryInfo from "../../components/search/SearchSecondaryInfo";
import SearchLanguages from "../../components/search/SearchLanguages";
import FormHelperText from "@material-ui/core/FormHelperText";

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: 15,
    display: "flex",
  },
  container: {
    height: "100%",
    width: "100%",
  },
  flexContainer: {
    display: "flex",
  },
}));

function FeaturesSettings() {
  const [saving, setSaving] = useState(false);
  const properties = useSelector((state) => {
    return { ...state.setting.applicationProperties };
  });
  const classes = useStyles();
  const { t } = useTranslation();
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch();
  const [updatedProperties, setUpdatedProperties] = useState([]);

  const handleCheckboxChange = (propertyKey) => (e) => {
    updateProperties(propertyKey, e.target.checked ? "true" : "false");
  };

  const updateProperties = (propertyKey, propertyValue) => {
    if (updatedProperties.indexOf(propertyKey) === -1) {
      setUpdatedProperties([...updatedProperties, propertyKey]);
    }
    dispatch(
      setApplicationProperties({
        ...properties,
        [propertyKey]: propertyValue,
      })
    );
  };

  const save = () => {
    setSaving(true);
    let updated = {};
    // so we only patch the changed props and not everything...
    for (const key of updatedProperties) {
      updated[key] = properties[key];
    }
    axios
      .patch("/application-property/", {
        ...updated,
      })
      .then(() => {
        enqueueSnackbar(t("properties_updated_snackbar"), {
          variant: "success",
        });
        setSaving(false);
      })
      .catch((err) => {
        enqueueSnackbar(t("properties_updated_error_snackbar"), {
          variant: "error",
        });
        setSaving(false);
      });
  };

  return (
    <div className={classes.container}>
      <div className={classes.header}>
        <Typography variant="h5" style={{ marginRight: 10 }}>
          {t("features_settings_header")}
        </Typography>
        <ActionButton
          variant="contained"
          color="primary"
          onClick={save}
          loading={saving}
        >
          {t("global_save")}
        </ActionButton>
      </div>
      <FormControl>
        <FormControlLabel
          label={t("app_feature_discussions_enabled")}
          control={
            <Checkbox
              value=""
              checked={properties[PropertyNames.DISCUSSIONS_ENABLED] === "true"}
              onChange={handleCheckboxChange(PropertyNames.DISCUSSIONS_ENABLED)}
              color="primary"
            />
          }
        />
        <FormHelperText>
          {t("app_feature_discussions_enabled_helper_text")}
        </FormHelperText>
      </FormControl>
    </div>
  );
}

export default FeaturesSettings;
